export type MainsailWwwConfig = {
	apiUrl: string;
	dreadnoughtImageUrl: string;
	cdnImageUrl: string;
	gangplankUrl: string;
	googleMapKey: string;
	smartLookKey: string | undefined;
};

export const configure = (): MainsailWwwConfig => {
	const config: { [K in keyof MainsailWwwConfig]: string | undefined } = {
		apiUrl: process.env["WWW_API_URL"],
		dreadnoughtImageUrl: process.env["WWW_DREADNOUGHT_IMAGE_URL"],
		cdnImageUrl: process.env["WWW_CDN_IMAGE_URL"],
		gangplankUrl: process.env["WWW_GANGPLANK_URL"],
		googleMapKey: process.env["WWW_GOOGLE_MAPS_KEY"],
		smartLookKey: process.env["WWW_SMARTLOOK_KEY"],
	};

	const errors: string[] = [];
	for(const [ key, value ] of Object.entries(config)) {
		if(!value) {
			if(key === "smartLookKey") {
				continue;
			}

			errors.push(`missing variable: "${key}"`);
			continue;
		}
	}

	if(errors.length) {
		throw new Error("Invalid configuration: " + errors.join(", "));
	}

	return config as MainsailWwwConfig;
};